import React from "react";
import banner from "assets/images/banner_purple_bg.jpeg";

const DefaultContainer = ({ children }) => {

  return (
    <div
      style={{
        display: "flex",
        position: "relative",
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <img
        src={banner}
        alt={"Banner"}
        style={{
          width: "100%",
          height: "119px",
          objectFit: "cover",
          borderRadius: 10,
          position: "absolute",
          top: 0,
          zIndex: 10,
        }}
      />
      <div
        style={{
          position: "absolute",
          top: 40,
          zIndex: 14,
          width: '100%',
          maxWidth: 800,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default DefaultContainer;
